(function ($) {
  $(function () {

    /*****
      Set some global variables
    *****/
    var template_url = $('#template_url').val();


    /*****
      Mobile nav toggle
    *****/
    $('.site-menu-toggle').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('is-active');
      $('html').toggleClass('nav-state-closed nav-state-open');
    });


    /*****
      Toggle work item text
    *****/
    if ($('.work-info-toggle').length) {
      $('.work-info-toggle').on('click', function (e) {
        e.preventDefault();
        $('.work-single').toggleClass('work-single-closed work-single-open');
      });
    }


    /*****
      Work item carousel
    *****/
    if ($('.work-single-image-carosel > .work-single-image-carosel-item').length > 1) {
      var $carousel = $('.work-single-image-carosel').flickity({
        cellAlign: 'left',
        cellSelector: '.work-single-image-carosel-item',
        contain: true,
        prevNextButtons: true,
        imagesLoaded: true,
        arrowShape: {
          x0: 25,
          x1: 75, y1: 50,
          x2: 75, y2: 45,
          x3: 30
        },
        pageDots: false,
        wrapAround: true,
        adaptiveHeight: true
      });

      // Little hack to resize carousel after load
      $carousel.flickity('resize');
      setTimeout(function () {
        $carousel.flickity('resize');
      }, 300);

      // Get some data in vars
      var flkty = $carousel.data('flickity');
      var $cells = $carousel.find('.work-single-image-carosel-item');

      // Auto-play video once selected
      function playOnSelect(event, index) {
        var video = flkty.selectedElement.querySelector('video');
        if (video) {
          video.play();
        }
      }
      playOnSelect();
      $carousel.on('select.flickity', playOnSelect);

      // Auto-pause if not selected slide
      $carousel.on('settle.flickity', function () {
        $cells.each(function (i, cell) {
          // do not unpause selected cell
          if (cell == flkty.selectedElement) {
            return;
          }
          var $video = $(cell).find('video');
          if ($video.length) {
            // pause video here
            $video[0].pause();
          }
        });
      });
    }


    /*****
      Email subscribe
    *****/
    if ($('.email-subscribe').length) {
      var $form = $('.email-subscribe');

      $form.on('submit', function (e) {
        e.preventDefault();

        var email = $form.find('input[name="EMAIL"]').val();

        $form.find('button').prop('disabled', true);

        $.ajax({
          method: "POST",
          url: template_url + "/_email_sub.php",
          data: {
            email: email
          }
        }).done(function (msg) {
          $form.find('button, input').addClass('hidden');
          $form.find('.email-subscribe-thanks').removeClass('hidden');
        });

      });


    }


  });
})(jQuery);
